import { Navigate, Outlet } from "react-router-dom";
import { useStore } from "../../context/AppContext";

export default function SignOutRoutes(){
    const { state } = useStore();

    if(state.user.authenticated){
        return <Navigate to="/" replace />;
    }
    
    return <Outlet />;
}